import { Palette } from '@mui/material'

export interface CustomPalette extends Palette {
	sidebar: {
		gray: string
		borderGray: string
	}
}

export default {
	primary: {
		main: '#484069', // Blue
	},
	secondary: {
		main: '#6528F7', // Electric Indigo
		dark: '#111315', // Night
	},
	text: {
		primary: '#111315', // Night
		grey: '#BDBDBD', // rmd-grey-400
		white: '#FFFFFF', // White
		darkGrey: '#48454D',
		lightGrey: '#87848C',
		darkBlue: '#484069',
		lighter: '#736A8C',
	},
	sidebar: {
		gray: '#F5F5F5',
		borderGray: '#0000001f',
	},
	brand: {
		main: '#623DF8', // violet
	},
	colors: {
		green: '#676C38',
		completed: '#52AB1B', //green
		backgroundWarn: '#F5EED2',
		warn: '#8A7500',
		grey: '#CAC9CF',
		lighter: '#736A8C',
		red: '#f44336',
	},
}
